/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { setLink } from '../../actions';

function BookLink({
  children, to, setLink: setMyLink, ...props
}) {
  const goTo = (e) => {
    e.preventDefault();
    setMyLink(to);
  };

  return (
    <NavLink className="book-link" {...props} to={to} onClick={goTo}>{children}</NavLink>
  );
}

export default connect(null, { setLink })(BookLink);
